import { FileParameter } from '@lmt/shared-types';
import { GlobalState } from '../../store/types';
import { MeasuredValue } from './types';

export const getMeasuredValues = (state: GlobalState) =>
  state.measurement.measuredValues;

export function getSourceNames(measuredValues: MeasuredValue[]): string[] {
  return measuredValues.map((value) => value.key);
}

export function getImportFile(state: GlobalState): FileParameter | undefined {
  return state.measurement.file;
}

export function getPdfFile(
  state: GlobalState,
): FileParameter | undefined | null {
  return state.measurement.pdfFile;
}
